import { BaseTranslation } from 'src/i18n/i18n-types';
import { CompanyRole } from 'src/pages/SettingsV2/const';

const companyRoles: Record<CompanyRole, string> = {
  ownerOrLeadership: 'Business Owner / Leadership Team',
  mediaBuyerOrCreativeStrategist: 'Media Buyer / Creative Strategist',
  videoEditorOrMotionDesigner: 'Video Editor / Motion Designer',
  designerCreative: 'Designer / Creative',
  brandManagerOrProducer: 'Brand Manager / Producer',
  socialMediaManager: 'Social Media Manager',
  other: 'Other role',
};

export const onboarding: BaseTranslation = {
  userInit: 'Loading MagicBrief...',
  verifyEmailTitle: 'Confirm it’s you',
  verifyEmailSubtitle: 'Enter the code sent to <>{email}<>',
  resend: 'Didn’t receive a code? <>Resend<>',
  changeUser: 'Not you? <>Sign in again<>',
  verifyReload: "I've verified on another browser or device",
  changeEmail: 'Change Email',
  currentEmail: 'Current Email',
  newEmail: 'New Email',
  emailSent: 'Email sent',
  verifying: 'Verifying your email...',
  emailVerified: 'Email verified',
  invalidCode: 'The code you entered is incorrect',
  companyRoles,
  step1Title: 'You’re a few steps away from your workspace',
  step1Description: 'Fill in your details to get started',
  step2Title: 'Connect ad account',
  step2Description: 'Connect your account to get insights',
  step3Title: 'Select pages to connect',
  step3Description: 'Select the ad pages you want to import data from',
  step4Title: 'Receive automated reports',
  step4Description: 'Select a platform to receive report summaries',
  connectPages: 'Connect pages',
  connectingPages: 'Connecting ad account...',
  setupLater: 'Setup later',
  success: {
    emailChanged:
      'Email address updated. A verification email has been re-sent.',
    invitationsSent: 'Invitations sent',
    setupComplete: 'Setup complete',
    setupCompleteDescription: 'You’ve successfully created your account',
  },
  errors: {
    invalidCharacters:
      "Only letters, hyphens (-) and apostrophes (') are allowed",
    invalidCharactersWorkspace:
      "Only letters, numbers, hyphens (-) and apostrophes (') are allowed",
    onboardSubmit:
      'An error occurred while submitting your onboarding information: {detail}',
    invalidLinkTitle: 'Email verification link invalid',
    invalidLinkDescription:
      'Somehow, the link to verify your email was missing an important piece of information. Try following the link again. Otherwise contact support by live chat or <>email<> for assistance.',
    inviteNoEmails:
      'To invite your team you need to provide at least one email address, or you can skip and send invites later.',
    interestsRequired: 'Select at least one of the following',
    verifyEmailTitle: 'Verification failed',
    verifyEmailDescription:
      'Something went wrong while verifying your email. Try following the link in the email you received again. Otherwise contact support by live chat or <>email<> for assistance.',
    verifyEmailChangeReauth:
      'We had some trouble authenticating you. You can try re-entering your password and trying again, or contact support.',
    verifyEmailChangeButAlreadyVerified:
      'It appears the email address you want to change has already been verified. Please reload the page or click "I\'ve verified..." to proceed. You can change your verified email in your profile settings at any time.',
    nameRequired: 'Your name is required',
    workspaceNameRequired: 'Workspace name is required',
    displayNameTooShort: 'Your name must be at least {n} characters long',
    displayNameTooLong: 'Your name must be less than {n} characters long',
    workspaceNameTooShort:
      'Workspace name must be at least {n} characters long',
    workspaceNameTooLong:
      'Workspace name must be less than {n} characters long',
  },
  activationCard: {
    adBreakdowns: 'Ad Breakdowns',
    adBreakdownsDescription:
      'Sync your ad account and see a visual breakdown of what’s working in real-time.',
    getWeeklyWraps: 'Get Weekly Wraps',
    getWeeklyWrapsDescription:
      'Get weekly wraps sent to your Slack, keep the whole team updated on autopilot.',
    followBrandsDescription:
      'Don’t fall behind, track of your competition by following any brand running ads.',
  },
  interests: {
    label: 'What are your main areas of focus?',
    adInspiration: 'Ad inspiration',
    creativeAnalytics: 'Creative analytics',
    trackCompetitors: 'Track competitors',
    createAndShareBriefs: 'Create and share briefs',
  },
  displayName: {
    label: 'Your Name',
    placeholder: 'Enter your name...',
  },
  workspaceName: {
    label: 'Workspace Name',
    placeholder: 'MagicBrief',
  },
};
